import React from "react";
import styles from "./styles.module.scss";

export default ({
    dataTestId,
    value,
    label,
    onChange,
    big,
    name,
    ariaLabel,
    // Create new prop for reverse label to prevent existing components from breaking
    reverseLabel = false,
}) => (
    <span className={big ? styles.toggleBig : styles.toggle}>
        <label className={styles.switch} aria-label={ariaLabel}>
            {label && (
                <span
                    className={`${styles.label} ${
                        reverseLabel ? styles.reserve : ""
                    }`}
                >
                    {label}
                </span>
            )}
            <input
                checked={value}
                value={value}
                name={name}
                onChange={onChange}
                type="checkbox"
                data-testid={dataTestId}
                aria-label={ariaLabel}
            />
            <span
                className={`${styles.slider} ${
                    reverseLabel ? styles.reserve : ""
                }`}
            />
        </label>
    </span>
);
